/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectCards } from 'swiper/modules';

Swiper.use([Navigation, Autoplay, Pagination, EffectCards]);
export function slider() {
    const logoSliderSelector = ".logo-slider__inner.swiper";
    const mediaContentSliderSelector = ".media-content-slider__inner.swiper";
    const widgetSliderSelector = ".banner__widgets--slider.swiper";
    const cardImageSliderSelector = ".card-accordion-mobile__container.swiper";
    const cardSliderSelector = ".content-cards__cards.swiper";
    const latestArticlesSliderSelector = ".articles-list__mobile.swiper";
    const quoteSliderSelector = ".quote-slider__inner.swiper";
    const reviewSliderSelector = ".review-slider__reviews.swiper";
    const contentMediaSliderSelector = ".content-media-slider__slider.swiper";
    const cardsSliderSelector = ".cards-slider__slider.swiper";
    const pricingSliderSelector = ".pricing-component__container.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {
        // Logo Slider
        const logoSlider = [];
        const logoSliderElements = document.querySelectorAll(logoSliderSelector);
        if (logoSliderElements) {
            logoSliderElements.forEach(slider => {

                logoSlider.push(new Swiper(slider, {
                    speed: 3000,
                    loop: true,
                    freeMode: true,
                    allowTouchMove: false,
                    slidesPerView: 'auto',
                    spaceBetween: 30,
                    autoplay: {
                        delay: 0.5,
                    },
                    breakpoints: {
                        // when window width is >= 768px
                        992: {
                            spaceBetween: 45,
                        },
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        const mediaContentSlider = [];
        const mediaContentSliderElements = document.querySelectorAll(mediaContentSliderSelector);
        if (mediaContentSliderElements) {
            mediaContentSliderElements.forEach((slider, sliderIndex) => {

                mediaContentSlider.push(new Swiper(slider, {
                    slidesPerView: 'auto',
                    spaceBetween: 15,
                    loop: true,
                    centeredSlides: true,
                    initialSlide: 0,
                    breakpoints: {
                        // when window width is >= 768px
                        992: {
                            spaceBetween: 45,
                        },
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                        renderBullet: function (index, className) {
                            // Helper function to find the correct slide by data-swiper-slide-index
                            const getSlideTag = (index) => {
                                const slide = Array.from(slider.querySelectorAll('.swiper-slide')).find(
                                    (el) => el.getAttribute('data-swiper-slide-index') == index
                                );
                                return slide ? slide.getAttribute("data-pagination") : `Slide ${index + 1}`;
                            };

                            // Get the tag from the correct slide
                            const tag = getSlideTag(index);

                            // Return formatted bullet with tag
                            return `<span class="${className}">${tag}</span>`;
                        }
                    },

                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Widget Slider
        const widgetSlider = [];
        const widgetSliderElements = document.querySelectorAll(widgetSliderSelector);
        if (widgetSliderElements) {
            widgetSliderElements.forEach(slider => {

                widgetSlider.push(new Swiper(slider, {
                    speed: 2500,
                    loop: true,
                    freeMode: true,
                    centeredSlides: true,
                    allowTouchMove: false,
                    slidesPerView: 2,
                    spaceBetween: 30,
                    autoplay: {
                        delay: 0.5,
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Card Image Slider
        const cardImageSlider = [];
        const cardImageSliderElements = document.querySelectorAll(cardImageSliderSelector);
        if (cardImageSliderElements) {
            cardImageSliderElements.forEach(slider => {
                cardImageSlider.push(new Swiper(slider, {
                    loop: true,
                    centeredSlides: true,
                    slidesPerView: 1.5,
                    spaceBetween: 30,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Card Slider
        const cardSlider = [];
        const cardSliderElements = document.querySelectorAll(cardSliderSelector);
        if (cardSliderElements) {
            cardSliderElements.forEach(slider => {
                cardSlider.push(new Swiper(slider, {
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    breakpoints: {
                        992: {
                            spaceBetween: 30,
                            slidesPerView: 2.5
                        },
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Latest Articles Slider
        const latestArticlesSlider = [];
        const latestArticlesSliderElements = document.querySelectorAll(latestArticlesSliderSelector);
        if (latestArticlesSliderElements) {
            latestArticlesSliderElements.forEach(slider => {
                latestArticlesSlider.push(new Swiper(slider, {
                    slidesPerView: 'auto',
                    spaceBetween: 15,
                    pagination: {
                        el: ".articles-list__mobile--pagination",
                        type: "bullets",
                        clickable: true,
                        enabled: true,
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Quote Slider
        const quoteSlider = [];
        const quoteSliderElements = document.querySelectorAll(quoteSliderSelector);
        if (quoteSliderElements) {
            quoteSliderElements.forEach(slider => {
                const slides = slider.querySelectorAll('.swiper-slide');

                quoteSlider.push(new Swiper(slider, {
                    direction: 'vertical',
                    slidesPerView: "auto",
                    autoHeight: true,
                    speed: 2500,
                    // autoplay: {
                    //     delay: 4000
                    // },
                    pagination: {
                        el: ".quote-slider__pagination",
                        type: "bullets",
                        clickable: true,
                        enabled: true,
                        renderBullet: (index, className) => {
                            if (index < slides.length) { // Limit bullet count
                                return `<span class="${className}"></span>`;
                            }
                            return ''; // Skip extra bullets
                        },
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Review Slider
        const reviewSlider = [];
        const reviewSliderElements = document.querySelectorAll(reviewSliderSelector);
        if (reviewSliderElements) {
            reviewSliderElements.forEach(slider => {
                reviewSlider.push(new Swiper(slider, {
                    slidesPerView: 1,
                    direction: "vertical",
                    effect: 'cards',
                    cardsEffect: {
                        slideShadows: false,
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Content Media Slider
        const contentMediaSlider = [];
        const contentMediaSliderElements = document.querySelectorAll(contentMediaSliderSelector);
        if (contentMediaSliderElements) {
            contentMediaSliderElements.forEach(slider => {
                contentMediaSlider.push(new Swiper(slider, {
                    slidesPerView: 1,
                    direction: "horizontal",
                    spaceBetween: 45,
                    speed: 2500,
                    autoplay: {
                        delay: 4000
                    },
                    breakpoints: {
                        992: {
                            spaceBetween: 0,
                            direction: "vertical"
                        }
                    },
                    pagination: {
                        el: ".content-media-slider__pagination",
                        type: "bullets",
                        clickable: true,
                        enabled: true,
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Cards Slider
        const cardsSlider = [];
        const cardsSliderElements = document.querySelectorAll(cardsSliderSelector);
        if (cardsSliderElements) {
            cardsSliderElements.forEach(slider => {
                cardsSlider.push(new Swiper(slider, {
                    loop: true,
                    centeredSlides: true,
                    slidesPerView: 1.5,
                    spaceBetween: 30,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    breakpoints: {
                        992: {
                            loop: false,
                            centeredSlides: false,
                            spaceBetween: 30,
                            slidesPerView: 3.5
                        },
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Pricing Component Slider
        const pricingSlider = [];
        const pricingSliderElements = document.querySelectorAll(pricingSliderSelector);
        if (pricingSliderElements) {
            pricingSliderElements.forEach(slider => {
                pricingSlider.push(new Swiper(slider, {
                    slidesPerView: 1.1,
                    spaceBetween: 15,
                    slidesOffsetAfter: 15,
                    slidesOffsetBefore: 15,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }
    }

    init();

}
